import Navbar from './components/Navbar';
import Hero from './components/Hero';
import FeatureGrid from './components/FeatureGrid';
import CategoryGrid from './components/CategoryGrid';
import SeoContent from './components/SeoContent';
import ArticleGrid from './components/ArticleGrid';
import Testimonials from './components/Testimonials';
import CtaSection from './components/CtaSection';
import Footer from './components/Footer';
import JsonLd from '@/components/base/JsonLd';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://yoybuy.rest';
const logoSrc = 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/67a09e300463e31c534fce7fbe7473f7.jpeg';

const homeJsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebSite',
      '@id': `${siteUrl}/#website`,
      url: siteUrl,
      name: 'Yoybuy.rest',
      description: 'Гид по заказам из Китая через Yoybuy Spreadsheet. Экономьте до 40% с прозрачными ценами и быстрой доставкой в Россию.',
      inLanguage: 'ru',
      potentialAction: {
        '@type': 'SearchAction',
        target: {
          '@type': 'EntryPoint',
          urlTemplate: 'https://kaspreadsheet.com/search?q={search_term_string}',
        },
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'Organization',
      '@id': `${siteUrl}/#organization`,
      name: 'Yoybuy',
      alternateName: 'Yoybuy Sheet',
      url: siteUrl,
      logo: {
        '@type': 'ImageObject',
        url: logoSrc,
        width: 256,
        height: 256,
      },
      sameAs: [
        'https://kaspreadsheet.com',
      ],
      contactPoint: {
        '@type': 'ContactPoint',
        contactType: 'customer support',
        availableLanguage: ['Russian', 'English'],
      },
    },
  ],
};

export default function Home() {
  return (
    <>
      <JsonLd data={homeJsonLd} />
      <Navbar />
      <main>
        <Hero />
        <FeatureGrid />
        <CategoryGrid />
        <SeoContent />
        <ArticleGrid />
        <Testimonials />
        <CtaSection />
      </main>
      <Footer />
    </>
  );
}